<template>
  <div class="w-full flex flex-col justify-center items-center h-full mt-9">
    <img src="@/assets/icons/no_data.svg" class="w-36" />
    <h1 class="my-1">Nothing to show here</h1>
    <p class="text-gray-400 text-center w-4/5 m-auto text-sm">
      Please add a new entity or manage the data table to see the content here
      <br />
      Thank you
    </p>
  </div>
</template>

<script>
export default {
  name: "NoDataShowing",
};
</script>

<style scoped></style>
